import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Form, Modal, Alert } from "react-bootstrap";
import axios from "axios";
import Message from "../components/Message";

const CategoryDiscountScreen = () => {
  const dispatch = useDispatch();

  // State for discounts list
  const [discounts, setDiscounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Popup modal states
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // or 'edit'
  const [editDiscount, setEditDiscount] = useState(null);

  // Form state
  const [category, setCategory] = useState("");
  const [percent, setPercent] = useState("");

  const { userInfo } = useSelector((state) => state.userLogin);

  const config = {
    headers: { Authorization: `Bearer ${userInfo.token}` },
  };

  // Fetch discounts from API
  const fetchDiscounts = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/category-discounts`,config);     //changed here. removed the config.
      setDiscounts(data);
      setLoading(false);
      setError("");
    } catch (err) {
      setLoading(false);
      setError(
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
      );
    }
  };

  useEffect(() => {
    fetchDiscounts();
  }, []);

  // Handle add/edit button click
  const openAddModal = () => {
    setModalMode("add");
    setCategory("");
    setPercent("");
    setShowModal(true);
  };

  const openEditModal = (discount) => {
    setModalMode("edit");
    setEditDiscount(discount);
    setCategory(discount.category);
    setPercent(discount.percent);
    setShowModal(true);
  };

  // Submit new or edited discount
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!category.trim() || !percent) {
        setError("Category and discount percent are required");
        return;
      }
      if (modalMode === "add") {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/category-discounts`,
          { category: category.trim(), percent: Number(percent) },
          config
        );
      } else {
        await axios.put(
          `${process.env.REACT_APP_BACKEND_URL}/api/category-discounts/${editDiscount._id}`,
          { percent: Number(percent) },
          config
        );
      }
      await fetchDiscounts();
      setShowModal(false);
      setError("");
    } catch (err) {
      setError(
        err.response && err.response.data.message
          ? err.response.data.message
          : err.message
      );
    }
  };

  // Delete discount
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure to delete this discount?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/category-discounts/${id}`, config);
        fetchDiscounts();
      } catch (err) {
        setError(
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message
        );
      }
    }
  };

  return (
    <>
      <h1>Category Discounts Management</h1>
      {error && <Message variant="danger">{error}</Message>}
      <Button variant="primary" className="mb-3" onClick={openAddModal}>
        Add New Discount
      </Button>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Category</th>
              <th>Discount %</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {discounts.map((d) => (
              <tr key={d._id}>
                <td>{d.category}</td>
                <td>{d.percent}</td>
                <td>
                  <Button
                    variant="info"
                    size="sm"
                    onClick={() => openEditModal(d)}
                    className="me-2"
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => handleDelete(d._id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {/* Modal for Add/Edit */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalMode === "add" ? "Add New Discount" : "Edit Discount"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Message variant="danger">{error}</Message>}
          <Form onSubmit={handleSubmit}>
            {modalMode === "add" && (
              <Form.Group className="mb-3" controlId="category">
                <Form.Label>Category</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter category"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                />
              </Form.Group>
            )}
            <Form.Group className="mb-3" controlId="percent">
              <Form.Label>Discount Percent</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter discount %"
                value={percent}
                onChange={(e) => setPercent(e.target.value)}
                min="0"
                max="100"
                required
              />
            </Form.Group>
            <Button type="submit" variant="primary">
              {modalMode === "add" ? "Add Discount" : "Update Discount"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CategoryDiscountScreen;
